import React from 'react';
import styled, { keyframes } from 'styled-components';
import { svg } from '../../common';

const { CogLarge, CogSmall, LaptopImage } = svg;

const rotateLargeCog = keyframes`
from {
  transform: rotate(360deg);
}

to {
  transform: rotate(0deg);
}`;

const rotateSmallCog = keyframes`
from {
  transform: rotate(0deg);
}

to {
  transform: rotate(360deg);
}`;

const ImageWrapper = styled.div`
  position: relative;

  svg:nth-child(1) {
    width: 30rem;
    height: auto;
  }

  svg:nth-child(2) {
    width: 30%;
    height: auto;
    position: absolute;
    top: 15%;
    left: 25%;
    animation: ${rotateLargeCog} 20s linear infinite;
  }

  svg:nth-child(3) {
    width: 20%;
    height: auto;
    position: absolute;
    top: 40%;
    left: 52%;
    animation: ${rotateSmallCog} 12s linear infinite;
  }

  @media screen and (min-width: 768px) {
    svg:nth-child(1) {
      width: 40rem;
    }
  }

  @media screen and (min-width: 1200px) {
    svg:nth-child(1) {
      width: 50rem;
    }
  }

  @media screen and (min-width: 1600px) {
    svg:nth-child(1) {
      width: 80rem;
    }
  }
`;

const MainImage: React.FC = () => {
  return (
    <ImageWrapper>
      <LaptopImage />
      <CogLarge />
      <CogSmall />
    </ImageWrapper>
  );
};

export default MainImage;
